// 공정 표준 참여 오류 — 화면 분기는 문구가 아니라 타입으로(0110·0111 RPC 가 올리는 힌트와 짝).

const named = (name: string, text: string) =>
  class extends Error {
    constructor(message: string = text) {
      super(message);
      this.name = name;
    }
  };

export const STANDARD_ARTICLE_MISSING_TEXT = "시공법 글을 찾을 수 없습니다";
export const STANDARD_ARTICLE_STALE_TEXT = "그 사이 다른 회사가 글을 고쳤습니다 — 새로고침한 뒤 다시 고쳐 주세요";
export const STANDARD_BASE_STALE_TEXT = "공정 표준 판이 새로 나왔습니다 — 새로고침한 뒤 다시 제안해 주세요";
export const STANDARD_ITEM_MISSING_TEXT = "공정 표준 항목을 찾을 수 없습니다";
export const STANDARD_CLOCK_TEXT = "기기 시각이 맞지 않습니다 — 시각을 확인한 뒤 다시 제안해 주세요";
export const STANDARD_PROPOSAL_MISSING_TEXT = "제안을 찾을 수 없습니다";
export const STANDARD_VOTE_OWN_TEXT = "우리 회사 제안에는 의견을 달 수 없습니다";
export const STANDARD_REVIEW_CLOSED_TEXT = "검토 기간이 끝난 제안입니다";
export const STANDARD_VOTE_DUP_TEXT = "이미 의견을 남긴 제안입니다";

export const ADMIN_STANDARD_NOTHING_TEXT = "결정할 제안이 없습니다";
export const ADMIN_STANDARD_BASE_STALE_TEXT = "그 사이 새 판이 나왔거나 예전 판을 기준으로 한 제안입니다 — 새로고침한 뒤 다시 확인해 주세요";
export const ADMIN_STANDARD_REVIEW_OPEN_TEXT = "검토 기간(7일)이 끝나지 않은 제안은 승인할 수 없습니다";
export const ADMIN_STANDARD_DECIDED_TEXT = "이미 결정된 제안이 있습니다 — 새로고침해 주세요";
export const ADMIN_STANDARD_CONFLICT_TEXT = "같은 항목·같은 숫자를 바꾸는 제안은 한 판에 하나만 승인할 수 있습니다";
export const ADMIN_STANDARD_VERSION_CONFLICT_TEXT = "그 사이 새 판이 나왔습니다 — 새로고침한 뒤 다시 승인해 주세요";

export class StandardArticleMissingError extends named("StandardArticleMissingError", STANDARD_ARTICLE_MISSING_TEXT) {}
export class StandardArticleStaleError extends named("StandardArticleStaleError", STANDARD_ARTICLE_STALE_TEXT) {}
export class StandardBaseStaleError extends named("StandardBaseStaleError", STANDARD_BASE_STALE_TEXT) {}
export class StandardItemMissingError extends named("StandardItemMissingError", STANDARD_ITEM_MISSING_TEXT) {}
export class StandardClockError extends named("StandardClockError", STANDARD_CLOCK_TEXT) {}
export class StandardProposalMissingError extends named("StandardProposalMissingError", STANDARD_PROPOSAL_MISSING_TEXT) {}
export class StandardVoteOwnError extends named("StandardVoteOwnError", STANDARD_VOTE_OWN_TEXT) {}
export class StandardReviewClosedError extends named("StandardReviewClosedError", STANDARD_REVIEW_CLOSED_TEXT) {}
export class StandardVoteDuplicateError extends named("StandardVoteDuplicateError", STANDARD_VOTE_DUP_TEXT) {}

export class AdminStandardNothingError extends named("AdminStandardNothingError", ADMIN_STANDARD_NOTHING_TEXT) {}
export class AdminStandardBaseStaleError extends named("AdminStandardBaseStaleError", ADMIN_STANDARD_BASE_STALE_TEXT) {}
export class AdminStandardReviewOpenError extends named("AdminStandardReviewOpenError", ADMIN_STANDARD_REVIEW_OPEN_TEXT) {}
export class AdminStandardDecidedError extends named("AdminStandardDecidedError", ADMIN_STANDARD_DECIDED_TEXT) {}
export class AdminStandardProposalMissingError extends named("AdminStandardProposalMissingError", STANDARD_PROPOSAL_MISSING_TEXT) {}
export class AdminStandardConflictError extends named("AdminStandardConflictError", ADMIN_STANDARD_CONFLICT_TEXT) {}
export class AdminStandardVersionConflictError extends named("AdminStandardVersionConflictError", ADMIN_STANDARD_VERSION_CONFLICT_TEXT) {}

// 회원 RPC(0110) 힌트 → 타입.
export const STANDARD_MEMBER_ERRORS: Record<string, new () => Error> = {
  process_standard_article_missing: StandardArticleMissingError,
  process_standard_article_stale: StandardArticleStaleError,
  process_standard_base_stale: StandardBaseStaleError,
  process_standard_item_missing: StandardItemMissingError,
  process_standard_clock: StandardClockError,
  process_standard_proposal_missing: StandardProposalMissingError,
  process_standard_vote_own: StandardVoteOwnError,
  process_standard_review_closed: StandardReviewClosedError,
  process_standard_vote_dup: StandardVoteDuplicateError,
};

// 운영자 RPC(0111) 힌트 → 타입.
export const STANDARD_ADMIN_ERRORS: Record<string, new () => Error> = {
  admin_standard_nothing: AdminStandardNothingError,
  admin_standard_base_stale: AdminStandardBaseStaleError,
  admin_standard_review_open: AdminStandardReviewOpenError,
  admin_standard_proposal_decided: AdminStandardDecidedError,
  admin_standard_proposal_missing: AdminStandardProposalMissingError,
  admin_standard_version_conflict: AdminStandardVersionConflictError,
};

export const STANDARD_MEMBER_HINTS: readonly string[] = Object.keys(STANDARD_MEMBER_ERRORS);
export const STANDARD_ADMIN_HINTS: readonly string[] = Object.keys(STANDARD_ADMIN_ERRORS);

export const standardErrorFromHint = (hint: string | null | undefined): Error | null => {
  if (!hint) return null;
  const type = STANDARD_MEMBER_ERRORS[hint] ?? STANDARD_ADMIN_ERRORS[hint];
  return type ? new type() : null;
};
